import { requestPDServer, handleFetchResponse } from '@/utils/fetchResponse';
import Cookies from 'js-cookie';

const baseUrl = process.env.VUE_APP_BASE_API_PD;
const myBaseUrl = process.env.VUE_APP_BASE_API;
const headers = {
  'Content-Type': 'application/json',
};

function setCookie() {
  const activeUser = localStorage.getItem('activeUser');
  if (activeUser) {
    const user = JSON.parse(activeUser);
    Cookies.set('tld-token', user.pdToken);
  }
}
/**
 * 个人资料
 */
export const getTalkytimesUserInfo = () => {
  return requestPDServer('/platform/private/personal-profile', {});
};
/**
 * 用户个人公开照片
 */
export const getPhotos = (userId) => {
  return requestPDServer(`/platform/operator/get-photos/${userId}`, {});
};

/**
 * 在线状态
 */
// {"ids":[30339782,97998131,94336936,101112691,99573680,102660397,110984607,99738999,104474193,109914550,120040427,69553295,119974964,91934905]}
export const getOnlineStatus50 = (data) => {
  // 将ids中的每一项转为数字类型
  data.ids = data.ids.map((item) => Number(item));
  return requestPDServer('/platform/online', data).catch((error) => {
    // 如果是 PD服务器请求失败: ConnectException: Connection timed out 错误，静默处理，返回空对象
    if (error && error.msg && error.msg.includes('PD服务器请求失败') && error.msg.includes('Connection timed out')) {
      console.log('在线状态查询失败（连接超时），静默处理');
      return {};
    }
    // 其他错误继续抛出
    return Promise.reject(error);
  });
};

/**
 * 分批查询在线状态 - 支持大量用户查询
 * @param {Object} data - 查询参数
 * @param {Array} data.ids - 用户ID数组
 * @param {number} batchSize - 每批查询的用户数量，默认50
 * @returns {Promise} 返回所有用户的在线状态
 */
export const getOnlineStatus = (data, batchSize = 15) => {
  setCookie();
  // 将ids中的每一项转为数字类型
  const ids = data.ids.map((item) => Number(item));

  if (ids.length === 0) {
    return Promise.resolve({});
  }

  // 如果用户数量不超过批次大小，直接调用原方法
  if (ids.length <= batchSize) {
    return getOnlineStatus50({ ids });
  }

  // 分批处理
  const batches = chunkArray(ids, batchSize);

  // 并发查询所有批次
  const promises = batches.map((batch, index) => {
    return getOnlineStatus50({ ids: batch }).then((res) => {
      return res;
    }).catch((error) => {
      // 如果是 PD服务器请求失败: ConnectException: Connection timed out 错误，静默处理，返回空对象
      if (error && error.msg && error.msg.includes('PD服务器请求失败') && error.msg.includes('Connection timed out')) {
        console.log('在线状态查询失败（连接超时），静默处理');
        return {};
      }
      // 其他错误也返回空对象，避免影响其他批次的查询
      return {};
    });
  });

  return Promise.all(promises)
    .then((results) => {
      // 合并所有批次的结果
      const allResults = {};
      results.forEach((result) => {
        if (result && typeof result === 'object') {
          Object.assign(allResults, result);
        }
      });

      return allResults;
    })
    .catch((error) => {
      // 如果是 PD服务器请求失败: ConnectException: Connection timed out 错误，静默处理，返回空对象
      if (error && error.msg && error.msg.includes('PD服务器请求失败') && error.msg.includes('Connection timed out')) {
        console.log('在线状态查询失败（连接超时），静默处理');
        return {};
      }
      // 其他错误也返回空对象，避免影响用户体验
      console.log('在线状态查询失败，静默处理:', error);
      return {};
    });
};

/**
 * 数组分批工具方法
 * @param {Array} array - 要分批的数组
 * @param {number} size - 每批的大小
 * @returns {Array} 分批后的二维数组
 */
const chunkArray = (array, size) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};
// 取消置顶用户
// /platform/chat/dialog/unpin
// idInterlocutor: 104474193
export const unpinUser = (data) => {
  return requestPDServer('/platform/chat/dialog/unpin', data);
};
// 置顶用户
// platform/chat/dialog/pin
// idInterlocutor: 104474193
export const pinUser = (data) => {
  return requestPDServer('/platform/chat/dialog/pin', data);
};
// 收藏或取消收藏用户
// /platform/chat/bookmark
// idRegularUser: 104474193
// bookmark: true 收藏 false 取消收藏
export const bookmarkUser = (data) => {
  return requestPDServer('/platform/chat/bookmark', data);
};
// 举报类型
// https://talkytimes.com/platform/abuse-report/reason-list
export const getAbuseReportReasonList = () => {
  return requestPDServer('/platform/abuse-report/reason-list', {});
};

// 获取黑名单
// https://talkytimes.com/platform/connection-block/list
// idLast: 0
// limit: 15
export const getConnectionBlockList = (data) => {
  return requestPDServer('/platform/connection-block/list', data);
};

// 移出黑名单
// https://talkytimes.com/platform/social-action/unblock
// idInterlocutor: 用户ID
export const removeConnectionBlock = (data) => {
  return requestPDServer('/platform/social-action/unblock', data);
};

// 获取全部礼物列表
// https://talkytimes.com/platform/present/real/present/list
// cursor: ""
// idRegularUser: 69593048
// limit: 30
export const getPresentList = (data) => {
  return requestPDServer('/platform/present/real/present/list', data);
};
// 获取心愿单列表
// https://talkytimes.com/platform/present/real/wish-list/get
export const getWishList = () => {
  return requestPDServer('/platform/present/real/wish-list/get', {});
};

// 编辑心愿单
// https://talkytimes.com/platform/present/real/wish-list/update
// idsPresents: [1,2,3] 礼物ID数组
export const updateWishList = (data) => {
  return requestPDServer('/platform/present/real/wish-list/update', data);
};

// 获取收礼记录（全部）
// https://talkytimes.com/platform/virtual-gift/received/list
export const getReceivedList = () => {
  return requestPDServer('/platform/virtual-gift/received/list', {});
};

// 获取收礼（分析）
// https://talkytimes.com/platform/virtual-gift/statistics
// dateFrom: "2025-07-26T08:53:02.104Z"
// dateTo: "2025-08-09T05:56:54.443Z"
export const getReceivedStatistics = (data) => {
  return requestPDServer('/platform/virtual-gift/statistics', data);
};

// 举报用户
// https://talkytimes.com/platform/abuse-report/create
// comment:"1",举报原因
// idUserTo:123886205,被举报用户ID
// reasonCode:"other",举报原因代码
// urlOriginal:"https://i.gstatvb.com/shpzkl4fj7o7sgtpa. a28d2441. jpg",举报证据图片
export const reportUser = (data) => {
  return requestPDServer('/platform/abuse-report/create', data);
};
// 拉黑用户
// https://talkytimes.com/platform/social-action/block
// comment: "1111111111111111111111111111111111111111111111111111",拉黑原因
// idInterlocutor: 123886205,被拉黑用户ID
export const blockUser = (data) => {
  return requestPDServer('/platform/social-action/block', data);
};
// 举报图片上传接口
// https://i.gstatvb.com/upload.php?app=shpzkl&sign=549a3e56
export const uploadImage = (data) => {
  return new Promise((resolve, reject) => {
    setCookie();
    return fetch(`${baseUrl}/upload.php?app=shpzkl&sign=549a3e56`, {
      method: 'POST',
      headers,
      body: JSON.stringify(data),
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 标记用户vip
// https://talkytimes.com/platform/contact-list/add
// "idUser":104474193
// "name":"vip"
export const addContactList = (data) => {
  return requestPDServer('/platform/contact-list/add', data);
};
// 移除vip
// https://talkytimes.com/platform/contact-list/remove
// "idUser":104474193
// "name":"vip"
export const removeContactList = (data) => {
  return requestPDServer('/platform/contact-list/remove', data);
};

// platform/social-action/follow
// idInterlocutor: 104474193
// follow: true 关注 false 取消关注
export const followUser = (data) => {
  return requestPDServer('/platform/social-action/follow', data);
};
// platform/social-action/unfollow
// idInterlocutor: 104474193
export const unfollowUser = (data) => {
  return requestPDServer('/platform/social-action/unfollow', data);
};

// 未读邮件数量
// {"threadsUnreadCount":1}
// platform/correspondence/statistic
export const getCorrespondenceStatistic = () => {
  return requestPDServer('/platform/correspondence/statistic', {});
};

// 根据token获取未读邮件数量
export const getCorrespondenceStatisticByToken = (data) => {
  return requestPDServer('/platform/correspondence/statistic', data);
};
